import React from "react"

import Link from "./link"

export default ({ event, linkTitle }) => (
	<React.Fragment>
		{linkTitle ? <Link to={event.fields.path}>{event.frontmatter.title}</Link> : event.frontmatter.title}
		{event.frontmatter.language && <span> [{event.frontmatter.language}]</span>}
	</React.Fragment>
)
